import { useState } from 'react'

import { AllianceSlider } from '../civilisations/Alliance'
import { AxolotlSlider } from '../civilisations/Axolotl'
import { LuminayanSlider } from '../civilisations/Luminayan'
import { PurgamenSlider } from '../civilisations/Purgamen'
import { RazatechSlider } from '../civilisations/Razatech'
import SecondaryLayout from '../layout/secondaryLayout'

const ViewMission = ({
  civilisation,
  component,
  pageTitle,
  vertical,
  remainingTime,
}) => {
  const [hasStaked, setHasStaked] = useState(false)

  return (
    <SecondaryLayout
      pageTitle={pageTitle}
      secondaryTitle={<SecondaryTitle remainingTime={remainingTime} />}
    >
      {civilisation === 'Alliance' ? (
        <AllianceSlider vertical={vertical} component={component} />
      ) : civilisation === 'Purgamen' ? (
        <PurgamenSlider vertical={vertical} component={component} />
      ) : civilisation === 'Luminayan' ? (
        <LuminayanSlider vertical={vertical} component={component} />
      ) : civilisation === 'Razatech' ? (
        <RazatechSlider vertical={vertical} component={component} />
      ) : (
        <AxolotlSlider vertical={vertical} component={component} />
      )}
    </SecondaryLayout>
  )
}

const SecondaryTitle = ({ remainingTime }) => (
  <p className="text-white pr-2 text-right">
    Remaining Time:
    <span className="text-cyanBlue font-ethnocentric pl-2 text-display--xl">
      {remainingTime}
    </span>
  </p>
)
export default ViewMission
